import BoqBulkController from "./boq_bulk_controller"

// Bulk selection on an Angebot's or a Rechnung's positions — the row editor's tree, the position
// grid (billing/position_grid/_grid) and the invoice's read-only table. The selection itself is
// boq-bulk's: a ticked Titel ticks the rows beneath it, and the forms receive the selection
// compacted, a fully ticked Titel as its own id (the server expands it, see PositionSelection).
// Added here: the Nachlass and Aufschlag panels beside the bulk edit and the select-all in the header. The
// invoice table has only a subset of the targets — hence the guards.
export default class extends BoqBulkController {
  static targets = ["reductionPanel", "markupPanel", "selectAll"]

  // Ticks or unticks every *visible* row, so an active filter narrows the select-all the same
  // way it narrows a shift-click range. A visible Titel then hands its state on like a click on
  // it would: to the rows of a folded Titel too, never to rows the filter hides (cascade).
  toggleAll(event) {
    const checked = event.target.checked
    const visible = this.visibleCheckboxes()
    visible.forEach((box) => {
      box.checked = checked
      box.indeterminate = false
    })
    visible.forEach((box) => this.cascade(box))
    this.lastChecked = null
    this.refresh()
  }

  refresh() {
    super.refresh()
    if (!this.checkboxTargets.some((box) => box.checked)) this.closePanels()
    this.syncSelectAll()
  }

  toggleEditPanel() {
    super.toggleEditPanel()
    this.hidePanels(["reduction", "markup"])
  }

  toggleReductionPanel() {
    this.reductionPanelTarget.classList.toggle("hidden")
    this.hidePanels(["edit", "markup"])
  }

  toggleMarkupPanel() {
    this.markupPanelTarget.classList.toggle("hidden")
    this.hidePanels(["edit", "reduction"])
  }

  // A markup adds to the EP rather than setting it, so the form must not survive a success: the
  // position grid syncs only the changed rows and leaves this panel open, and a second Enter would
  // raise the prices again. A refusal keeps the value, so it can be corrected.
  markupApplied(event) {
    if (!event.detail.success) return
    event.target.reset()
    this.markupPanelTarget.classList.add("hidden")
  }

  closePanels() {
    this.hidePanels(["edit", "reduction", "markup"])
  }

  // The invoice table has no edit panel, so each one is looked up rather than required.
  hidePanels(names) {
    names.forEach((name) => this.targets.find(`${name}Panel`)?.classList.add("hidden"))
  }

  syncSelectAll() {
    if (!this.hasSelectAllTarget) return
    const visible = this.visibleCheckboxes()
    const checked = visible.filter((box) => box.checked).length
    this.selectAllTarget.checked = visible.length > 0 && checked === visible.length
    this.selectAllTarget.indeterminate = checked > 0 && checked < visible.length
  }

  visibleCheckboxes() {
    return this.checkboxTargets.filter((box) => box.offsetParent !== null)
  }
}
